export default __webpack_public_path__ + "static/media/1872.848dc4e2.png";